/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileLinkLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FileLinkLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m47.818 24.7-.516-.516a7.508 7.508 0 0 0-10.605 0L31.182 29.7a7.508 7.508 0 0 0 0 10.605l.516.516a7.466 7.466 0 0 0 8.812 1.309l.066-.066a1.58 1.58 0 0 0 0-2.121 2.615 2.615 0 0 0-.935-.8 4.5 4.5 0 0 1-5.823-.441l-.516-.516a4.505 4.505 0 0 1 0-6.363l5.516-5.523a4.505 4.505 0 0 1 6.363 0l.516.516a4.492 4.492 0 0 1 .366 5.915c.12.109.245.212.361.327l.516.516c.43.432.821.9 1.17 1.4a7.5 7.5 0 0 0-.292-10.274Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M44.3 35.182a7.507 7.507 0 0 0-8.79-1.33l-.088.087a1.5 1.5 0 0 0 0 2.121l.516.516c.122.12.264.216.421.284a4.47 4.47 0 0 1 5.821.442l.516.516a4.505 4.505 0 0 1 0 6.363l-5.514 5.52a4.505 4.505 0 0 1-6.363 0l-.516-.517a4.492 4.492 0 0 1-.366-5.915c-.12-.109-.245-.212-.361-.327l-.516-.516c-.43-.434-.82-.905-1.168-1.407a7.5 7.5 0 0 0 .29 10.281l.516.516a7.507 7.507 0 0 0 10.605 0l5.515-5.516a7.508 7.508 0 0 0 0-10.605l-.518-.513Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m47.302 24.184.516.516a7.5 7.5 0 0 1 2.169 5.792 7.5 7.5 0 0 0-2.169-4.792l-.516-.516a7.508 7.508 0 0 0-10.605 0L31.182 30.7a7.508 7.508 0 0 0-2.176 4.802 7.508 7.508 0 0 1 2.176-5.802l5.515-5.516a7.508 7.508 0 0 1 10.605 0Zm-6.398 17.32a1.578 1.578 0 0 0-.328-1.56 2.614 2.614 0 0 0-.935-.801 4.5 4.5 0 0 1-5.823-.44l-.516-.517a4.505 4.505 0 0 1-1.288-2.681 4.505 4.505 0 0 0 1.288 3.681l.516.516a4.5 4.5 0 0 0 5.823.441c.37.188.692.463.935.8.148.164.259.355.328.56Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M46.974 30.482a4.492 4.492 0 0 1-.911 2.249c.041.038.083.074.125.111.08.07.16.14.236.216l.046.046a4.492 4.492 0 0 0 .505-2.622Zm-6.851 2.594a7.507 7.507 0 0 1 4.177 2.106l.518.513a7.508 7.508 0 0 1 2.176 5.803 7.508 7.508 0 0 0-2.176-4.803l-.518-.513a7.507 7.507 0 0 0-8.79-1.33l-.088.087a1.5 1.5 0 0 0-.353.56 1.5 1.5 0 0 1 .353-1.56l.088-.088a7.507 7.507 0 0 1 4.613-.775Zm3.861 8.424a4.505 4.505 0 0 1-1.288 2.681l-5.514 5.52a4.505 4.505 0 0 1-6.363 0l-.516-.517a4.492 4.492 0 0 1-1.277-2.666 4.49 4.49 0 0 0 1.277 3.666l.516.516a4.505 4.505 0 0 0 6.363 0l5.514-5.519a4.505 4.505 0 0 0 1.288-3.681ZM29.53 43.896c.117-.218.253-.428.407-.627l-.122-.108-.003-.003a5.28 5.28 0 0 1-.236-.216l-.516-.516c-.43-.434-.82-.905-1.168-1.407a7.5 7.5 0 0 0-1.881 5.487 7.5 7.5 0 0 1 1.881-4.487c.348.502.738.973 1.168 1.407l.47.47Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileLinkLarge
};
